import { useAppTheme } from './ThemeContext';
import VehicleThumbnail from '../assets/images/vehicle-thumbnail.png';
import VehicleThumbnailLight from '../assets/images/vehicle-thumbnail-light-new.svg';

function useVehicleThumbnail(): string {
  const { themeMode } = useAppTheme();

  return themeMode === 'light' ? VehicleThumbnailLight : VehicleThumbnail;
}

export default useVehicleThumbnail;
